import Metamask from './icons/Metamask'
import MathWallet from './icons/MathWallet'
import TokenPocket from './icons/TokenPocket'
import TrustWallet from './icons/TrustWallet'
import WalletConnect from './icons/WalletConnect'
import CoinbaseWallet from './icons/CoinbaseWallet'
import Klever from './icons/Klever'
import BinanceChain from './icons/BinanceChain'
import Blocto from './icons/Blocto'
import Coin98 from './icons/Coin98'
import Bitkeep from './icons/Bitkeep'

import { Config, ConnectorNames } from './types'

const connectors: Config[] = [
  {
    title: 'Metamask (Recommended)',
    icon: Metamask,
    connectorId: ConnectorNames.Injected,
    fathomID: 'RPITS1R9',
    walletID: 'metamask',
  },
  {
    title: 'Bitkeep',
    icon: Bitkeep,
    connectorId: ConnectorNames.Injected,
    fathomID: 'BCDSW5L1',
    walletID: 'bitkeep',
  },
  {
    title: 'Coin98',
    icon: Coin98,
    connectorId: ConnectorNames.Injected,
    fathomID: 'PLVUGNVO',
    walletID: 'coin98',
  },
  {
    title: 'Coinbase Wallet',
    icon: CoinbaseWallet,
    connectorId: ConnectorNames.CoinbaseWallet,
    fathomID: '8LLSJBOR',
    walletID: 'coinbaseWallet',
  },
  { title: 'Klever', icon: Klever, connectorId: ConnectorNames.Injected, fathomID: 'HVJBEGIG', walletID: 'klever' },
  {
    title: 'MathWallet',
    icon: MathWallet,
    connectorId: ConnectorNames.Injected,
    fathomID: 'MJNUFWDK',
    walletID: 'mathWallet',
  },
  {
    title: 'TrustWallet',
    icon: TrustWallet,
    connectorId: ConnectorNames.Injected,
    fathomID: '1AE78PKB',
    walletID: 'trustWallet',
  },
  {
    title: 'TokenPocket',
    icon: TokenPocket,
    connectorId: ConnectorNames.Injected,
    fathomID: '1EQPEFNH',
    walletID: 'tokenPocket',
  },
  {
    title: 'WalletConnect',
    icon: WalletConnect,
    connectorId: ConnectorNames.WalletConnect,
    fathomID: 'PBFYPUUQ',
    walletID: 'walletConnect',
  },
  {
    title: 'Binance Chain Wallet',
    icon: BinanceChain,
    connectorId: ConnectorNames.BSC,
    fathomID: 'S1FNEV6R',
    walletID: 'binanceChain',
  },
  {
    title: 'Blocto',
    icon: Blocto,
    connectorId: ConnectorNames.Blocto,
    fathomID: 'AXOFZIML',
    walletID: 'blocto',
  },
]

export default connectors
export const connectorLocalStorageKey = 'connectorId'
export const walletLocalStorageKey = 'walletId'
